(function ($) {
  'use strict';

  // ============================================
  // CONFIGURATION
  // ============================================
  const CONFIG = {
    DEBOUNCE_MS: 400,
    CANVAS_SIZE: 600,
    RENDER_SIZE: 2400,
    CANVAS_STROKE: 0.35,
    SVG_STROKE: 0
  };

  // Font configuration with Google Fonts URLs for embedding
  const FONTS = [
    {
      name: 'Loud',
      family: '"Anton", Impact, "Arial Black", sans-serif',
      weight: '400',
      lineHeight: 1.15,
      googleFont: 'Anton'
    },
    {
      name: 'Meme',
      family: '"Kanit", "Impact", sans-serif',
      weight: '800',
      lineHeight: 1.0,
      googleFont: 'Kanit:wght@800'
    },
    {
      name: 'Retro',
      family: '"Monoton", cursive',
      weight: '400',
      lineHeight: 1.0,
      googleFont: 'Monoton'
    },
    {
      name: 'Skool',
      family: '"Schoolbell", cursive',
      weight: '400',
      lineHeight: 1.0,
      googleFont: 'Schoolbell'
    },
    {
      name: 'Orbit',
      family: '"Orbitron", sans-serif',
      weight: '700',
      lineHeight: 1.0,
      googleFont: 'Orbitron:wght@700'
    },
    {
      name: 'GOTH',
      family: '"Uncial Antiqua", cursive',
      weight: '400',
      lineHeight: 1.0,
      googleFont: 'Uncial+Antiqua'
    },
    {
      name: 'Tailspin',
      family: '"Mystery Quest", cursive',
      weight: '400',
      lineHeight: 1.0,
      googleFont: 'Mystery+Quest'
    },
    {
      name: 'Fancy',
      family: '"Cookie", "Brush Script MT", cursive',
      weight: '400',
      lineHeight: 0.85,
      useXHeightSpacing: true,
      googleFont: 'Cookie'
    }
  ];

  const FONT_MAP = {
    'loud': 'Loud',
    'meme': 'Meme',
    'retro': 'Retro',
    'skool': 'Skool',
    'orbit': 'Orbit',
    'goth': 'GOTH',
    'tailspin': 'Tailspin',
    'fancy': 'Fancy'
  };

  const PRICE_GRID = {
    2: { 1: 3.99, 5: 14.95, 10: 20.16, 20: 25.73, 30: 30.40, 50: 38.42, 75: 47.14, 100: 55.01, 200: 82.20, 300: 105.85 },
    3: { 1: 4.99, 5: 19.95, 10: 25.83, 20: 34.28, 30: 41.26, 50: 53.10, 75: 65.78, 100: 77.10, 200: 115.46, 300: 148.09 },
    4: { 1: 5.99, 5: 24.95, 10: 31.87, 20: 43.37, 30: 52.80, 50: 68.70, 75: 85.60, 100: 100.59, 200: 150.81, 300: 193.00 },
    5: { 1: 6.99, 5: 29.95, 10: 38.19, 20: 52.88, 30: 64.88, 50: 85.03, 75: 106.34, 100: 125.16, 200: 187.80, 300: 239.99 },
    6: { 1: 7.99, 5: 34.95, 10: 44.74, 20: 62.73, 30: 77.40, 50: 101.96, 75: 127.84, 100: 150.65, 200: 226.16, 300: 288.72 }
  };

  // ============================================
  // MOCKUP CONFIGURATIONS WITH SIZE VARIANTS
  // ============================================
  const MOCKUP_CONFIGS = {
    bottle: {
      base: {
        top: '58%',
        left: '50%',
        width: '28%',
        transform: 'translateX(-50%) translateY(-50%)',
        transformOrigin: 'center center',
        clipPath: 'polygon(0% 4%, 10% 1.8%, 20% 0.6%, 30% 0.2%, 40% 0%, 50% 0%, 60% 0%, 70% 0.2%, 80% 0.6%, 90% 1.8%, 100% 4%, 100% 96%, 90% 98.2%, 80% 99.4%, 70% 99.8%, 60% 100%, 50% 100%, 40% 100%, 30% 99.8%, 20% 99.4%, 10% 98.2%, 0% 96%)'
      },
      sizes: {
        2: { top: '60%', left: '50%', width: '14%' },
        3: { top: '59%', left: '50%', width: '21%' },
        4: { top: '58%', left: '50%', width: '28%' },
        5: { top: '57%', left: '50%', width: '35%' },
        6: { top: '56%', left: '50%', width: '42%' }
      }
    },
    skateboard: {
      base: {
        top: '51%',
        left: '52%',
        width: '22%',
        transform: 'translateX(-50%) translateY(-50%) perspective(800px) rotateY(-8deg) rotateX(24deg) rotate(26deg)',
        transformOrigin: 'center center'
      },
      sizes: {
        2: { top: '52%', left: '51%', width: '11%' },
        3: { top: '51%', left: '52%', width: '14%' },
        4: { top: '51.5%', left: '51.5%', width: '17%' },
        5: { top: '51%', left: '50%', width: '21%' },
        6: { top: '51%', left: '51%', width: '25%' }
      }
    },
    laptop: {
      base: {
        top: '50%',
        left: '58%',
        width: '22%',
        transform: 'translateX(-50%) translateY(-50%) perspective(200px) rotateY(25deg) rotateX(2deg) skewY(-6deg) skew(8deg)',
        transformOrigin: 'center center'
      },
      sizes: {
        2: { top: '45%', left: '76%', width: '13%' },
        3: { top: '45%', left: '76%', width: '16%' },
        4: { top: '45%', left: '76%', width: '19%' },
        5: { top: '45%', left: '76%', width: '22%' },
        6: { top: '45%', left: '76%', width: '24%' }
      }
    },
    car: {
      base: {
        top: '28%',
        left: '50%',
        width: '32%',
        transform: 'translateX(-50%) translateY(-50%)',
        transformOrigin: 'center center'
      },
      sizes: {
        2: { top: '52%', left: '52%', width: '11%' },
        3: { top: '50%', left: '52.5%', width: '14%' },
        4: { top: '48%', left: '53%', width: '17%' },
        5: { top: '46%', left: '53.5%', width: '21%' },
        6: { top: '44%', left: '54%', width: '24%' }
      }
    }
  };

  function getConfigForSize(mockupType, size) {
    const config = MOCKUP_CONFIGS[mockupType];
    if (!config) return null;

    const sizeNum = parseInt(size) || 4;
    const sizeOverrides = config.sizes[sizeNum] || config.sizes[4];

    return {
      top: sizeOverrides.top || config.base.top,
      left: sizeOverrides.left || config.base.left,
      width: sizeOverrides.width || config.base.width,
      transform: config.base.transform,
      transformOrigin: config.base.transformOrigin,
      clipPath: config.base.clipPath || null
    };
  }

  // ============================================
  // STATE MANAGEMENT
  // ============================================
  class StickerDesigner {
    constructor() {
      // Create an offscreen SVG for rendering - this is our single source of truth
      this.renderSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      this.renderSvg.setAttribute('width', CONFIG.CANVAS_SIZE);
      this.renderSvg.setAttribute('height', CONFIG.CANVAS_SIZE);
      this.renderSvg.setAttribute('viewBox', `0 0 ${CONFIG.CANVAS_SIZE} ${CONFIG.CANVAS_SIZE}`);
      this.renderSvg.setAttribute('overflow', 'visible');
      this.renderSvg.style.position = 'absolute';
      this.renderSvg.style.left = '-9999px';
      this.renderSvg.style.top = '-9999px';
      document.body.appendChild(this.renderSvg);

      // Create offscreen canvas for contour tracing
      this.renderCanvas = document.createElement('canvas');
      this.renderCanvas.width = CONFIG.RENDER_SIZE;
      this.renderCanvas.height = CONFIG.RENDER_SIZE;

      this.renderTimeout = null;
      this.previewTimeout = null;
      this.fontCache = new Map();
      
      // Store rendered SVG data for mockups and previews
      this.lastUncroppedSvgHtml = null;
      this.lastCroppedContent = null;
      this.lastCroppedViewBox = null;
      this.lastViewBox = null;

      this.init();
    }

    // ============================================
    // STATE HELPERS
    // ============================================
    getState() {
      const text = $('#sticker-text').val() || 'SAY IT\nwith a\nSTICKER';
      const shapeValue = $('input[name="shape"]:checked').val() || 'Contour';
      const fontValue = $('input[name="wd-font"]:checked').val() || 'loud';

      return {
        text,
        shape: shapeValue.toLowerCase(),
        shapeText: shapeValue,
        fontFamily: FONT_MAP[fontValue] || 'Loud',
        textColor: $('input[name="wd-text-color"]:checked').val() || '#FFFFFF',
        outlineColor: $('input[name="wd-outline-color"]:checked').val() || '#FFFFFF',
        bgColor: $('input[name="wd-bg-color"]:checked').val() || '#000000',
        outlineThickness: (parseInt($('.wd-outline-range').val()) || 0) / 100,
        laminate: $('input[name="uv-laminate"]:checked').val() || 'Satin'
      };
    }

    getSelectedValue(name) {
      return $(`input[name="${name}"]:checked`).val();
    }

    getSelectedSize() {
      return parseInt($('[name="wd-size"]:checked').val()) || 4;
    }

    // ============================================
    // FONT LOADING & EMBEDDING
    // ============================================
    async loadFontAsBase64(fontConfig) {
      const cacheKey = fontConfig.googleFont;

      if (this.fontCache.has(cacheKey)) {
        return this.fontCache.get(cacheKey);
      }

      try {
        const testChars = encodeURIComponent(
          'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789' +
          '!@#$%^&*()_+-=[]{}|;:\'",.<>?/\\`~ '
        );
        const cssUrl = `https://fonts.googleapis.com/css2?family=${fontConfig.googleFont}&text=${testChars}&display=swap`;

        const cssResponse = await fetch(cssUrl, {
          headers: {
            'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36'
          }
        });

        let cssText = await cssResponse.text();

        const fontFaceRegex = /@font-face\s*\{[^}]+\}/g;
        const fontFaces = cssText.match(fontFaceRegex) || [];

        if (fontFaces.length === 0) {
          console.warn('No @font-face rules found in CSS');
          return null;
        }

        const embeddedFontFaces = [];

        for (const fontFace of fontFaces) {
          const urlMatch = fontFace.match(/src:\s*url\(([^)]+)\)/);
          if (!urlMatch) continue;

          const fontUrl = urlMatch[1].replace(/['"]/g, '');

          try {
            const fontResponse = await fetch(fontUrl);
            if (!fontResponse.ok) continue;

            const fontBlob = await fontResponse.blob();

            const base64 = await new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(fontBlob);
            });

            const fontFormat = fontUrl.includes('.woff2') ? 'woff2' :
              fontUrl.includes('.woff') ? 'woff' :
                fontUrl.includes('.ttf') ? 'truetype' : 'woff2';

            const unicodeRangeMatch = fontFace.match(/unicode-range:\s*([^;]+);/);
            const unicodeRange = unicodeRangeMatch ? unicodeRangeMatch[1].trim() : null;

            const fontStyleMatch = fontFace.match(/font-style:\s*([^;]+);/);
            const fontStyle = fontStyleMatch ? fontStyleMatch[1].trim() : 'normal';

            const fontFamilyName = fontConfig.googleFont.split(':')[0].replace(/\+/g, ' ');
            let embeddedRule = `
              @font-face {
                font-family: '${fontFamilyName}';
                font-style: ${fontStyle};
                font-weight: ${fontConfig.weight};
                src: url(${base64}) format('${fontFormat}');
                ${unicodeRange ? `unicode-range: ${unicodeRange};` : ''}
              }
            `;

            embeddedFontFaces.push(embeddedRule);
          } catch (fetchError) {
            console.warn('Failed to fetch font file:', fontUrl, fetchError);
          }
        }

        if (embeddedFontFaces.length === 0) {
          return await this.loadFontFallback(fontConfig);
        }

        const result = embeddedFontFaces.join('\n');
        this.fontCache.set(cacheKey, result);
        return result;

      } catch (error) {
        console.error('Error loading font:', error);
        return await this.loadFontFallback(fontConfig);
      }
    }

    async loadFontFallback(fontConfig) {
      try {
        const cssUrl = `https://fonts.googleapis.com/css2?family=${fontConfig.googleFont}&display=swap`;
        const cssResponse = await fetch(cssUrl);
        const cssText = await cssResponse.text();

        const urlMatches = cssText.matchAll(/src:\s*url\(([^)]+)\)/g);
        const embeddedFontFaces = [];
        const fontFamilyName = fontConfig.googleFont.split(':')[0].replace(/\+/g, ' ');

        for (const match of urlMatches) {
          const fontUrl = match[1].replace(/['"]/g, '');

          try {
            const fontResponse = await fetch(fontUrl);
            if (!fontResponse.ok) continue;

            const fontBlob = await fontResponse.blob();
            const base64 = await new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.readAsDataURL(fontBlob);
            });

            const fontFormat = fontUrl.includes('.woff2') ? 'woff2' :
              fontUrl.includes('.woff') ? 'woff' : 'truetype';

            embeddedFontFaces.push(`
              @font-face {
                font-family: '${fontFamilyName}';
                font-weight: ${fontConfig.weight};
                src: url(${base64}) format('${fontFormat}');
              }
            `);
          } catch (e) {
            console.warn('Fallback font fetch failed:', fontUrl);
          }
        }

        return embeddedFontFaces.length > 0 ? embeddedFontFaces.join('\n') : null;
      } catch (error) {
        console.error('Fallback font loading failed:', error);
        return null;
      }
    }

    // ============================================
    // CONTOUR TRACING ALGORITHM
    // ============================================
    traceContour(imageData, width, height) {
      const data = imageData.data;
      const threshold = 128;
      const visited = new Uint8Array(width * height);

      const dirs = [
        [0, -1], [1, -1], [1, 0], [1, 1],
        [0, 1], [-1, 1], [-1, 0], [-1, -1]
      ];

      const isOpaque = (x, y) => {
        if (x < 0 || x >= width || y < 0 || y >= height) return false;
        return data[(y * width + x) * 4 + 3] > threshold;
      };

      const traceOneComponent = (startX, startY) => {
        const points = [];
        let x = startX, y = startY;
        let dir = 7;
        const maxIterations = width * height;

        do {
          visited[y * width + x] = 1;
          points.push([x, y]);

          let found = false;
          for (let i = 0; i < 8; i++) {
            const checkDir = (dir + i) % 8;
            const nx = x + dirs[checkDir][0];
            const ny = y + dirs[checkDir][1];

            if (isOpaque(nx, ny)) {
              x = nx;
              y = ny;
              dir = (checkDir + 5) % 8;
              found = true;
              break;
            }
          }

          if (!found || points.length > maxIterations) break;
        } while (x !== startX || y !== startY);

        return points;
      };

      const allComponents = [];
      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          const idx = y * width + x;
          if (isOpaque(x, y) && !visited[idx]) {
            const component = traceOneComponent(x, y);
            if (component.length > 100) {
              allComponents.push(component);
            }
          }
        }
      }

      if (allComponents.length === 0) return '';

      let combinedPath = '';

      for (const points of allComponents) {
        const step = Math.max(1, Math.floor(points.length / 250));
        let simplified = [];
        for (let i = 0; i < points.length; i += step) {
          simplified.push(points[i]);
        }

        if (simplified.length === 0) continue;

        for (let iteration = 0; iteration < 5; iteration++) {
          const newPoints = [];
          for (let i = 0; i < simplified.length; i++) {
            const current = simplified[i];
            const next = simplified[(i + 1) % simplified.length];

            newPoints.push(
              [current[0] * 0.75 + next[0] * 0.25, current[1] * 0.75 + next[1] * 0.25],
              [current[0] * 0.25 + next[0] * 0.75, current[1] * 0.25 + next[1] * 0.75]
            );
          }
          simplified = newPoints;
        }

        const finalSmoothed = [];
        for (let i = 0; i < simplified.length; i++) {
          const prev = simplified[(i - 1 + simplified.length) % simplified.length];
          const current = simplified[i];
          const next = simplified[(i + 1) % simplified.length];

          const v1 = [current[0] - prev[0], current[1] - prev[1]];
          const v2 = [next[0] - current[0], next[1] - current[1]];

          const crossProduct = v1[0] * v2[1] - v1[1] * v2[0];
          const dotProduct = v1[0] * v2[0] + v1[1] * v2[1];

          if (crossProduct < 0 && dotProduct < 0) {
            finalSmoothed.push([
              (prev[0] + current[0] * 2 + next[0]) / 4,
              (prev[1] + current[1] * 2 + next[1]) / 4
            ]);
          } else {
            finalSmoothed.push(current);
          }
        }

        if (finalSmoothed.length > 0) {
          combinedPath += ` M ${finalSmoothed[0][0]} ${finalSmoothed[0][1]}`;
          for (let i = 1; i < finalSmoothed.length; i++) {
            combinedPath += ` L ${finalSmoothed[i][0]} ${finalSmoothed[i][1]}`;
          }
          combinedPath += ' Z';
        }
      }

      return combinedPath.trim();
    }

    // ============================================
    // GAP FILLING ALGORITHM
    // ============================================
    applyGapFilling(imageData, width, height, lineYPositions, fontSize, bgColor) {
      const data = imageData.data;
      const threshold = 128;

      const bgR = parseInt(bgColor.slice(1, 3), 16);
      const bgG = parseInt(bgColor.slice(3, 5), 16);
      const bgB = parseInt(bgColor.slice(5, 7), 16);

      const fillPixel = (x, y) => {
        const idx = (y * width + x) * 4;
        data[idx] = bgR;
        data[idx + 1] = bgG;
        data[idx + 2] = bgB;
        data[idx + 3] = 255;
      };

      const isOpaqueAt = (x, y) => {
        if (x < 0 || x >= width || y < 0 || y >= height) return false;
        return data[(y * width + x) * 4 + 3] > threshold;
      };

      for (let lineIdx = 0; lineIdx < lineYPositions.length; lineIdx++) {
        const y = lineYPositions[lineIdx];
        const lineTop = Math.floor(y - fontSize * 0.9);
        const lineBottom = Math.ceil(y + fontSize * 0.4);

        let lineMinX = width, lineMaxX = 0;
        for (let ly = lineTop; ly < lineBottom; ly++) {
          for (let x = 0; x < width; x++) {
            if (isOpaqueAt(x, ly)) {
              lineMinX = Math.min(lineMinX, x);
              lineMaxX = Math.max(lineMaxX, x);
            }
          }
        }

        if (lineMinX >= width) continue;

        const baseGap = 0.45;
        const extraGap = 0.25 * 0.8;
        const maxGapSize = fontSize * (baseGap + extraGap);

        for (let ly = lineTop; ly < lineBottom; ly++) {
          let firstOpaqueX = -1, lastOpaqueX = -1;

          for (let x = lineMinX; x <= lineMaxX; x++) {
            if (isOpaqueAt(x, ly)) {
              let consecutiveCount = 0;
              for (let checkX = x; checkX <= Math.min(x + 5, lineMaxX); checkX++) {
                if (isOpaqueAt(checkX, ly)) consecutiveCount++;
                else break;
              }

              if (consecutiveCount >= 3) {
                if (firstOpaqueX === -1) firstOpaqueX = x;
                lastOpaqueX = x;
              }
            }
          }

          if (firstOpaqueX === -1) continue;

          let gapStart = -1;
          for (let x = firstOpaqueX; x <= lastOpaqueX; x++) {
            const isTransparent = !isOpaqueAt(x, ly);

            if (isTransparent && gapStart === -1) {
              gapStart = x;
            } else if (!isTransparent && gapStart !== -1) {
              if (x - gapStart <= maxGapSize) {
                for (let gx = gapStart; gx < x; gx++) fillPixel(gx, ly);
              }
              gapStart = -1;
            }
          }
        }

        const maxVerticalGap = fontSize * 0.375;
        for (let x = lineMinX; x <= lineMaxX; x++) {
          let firstOpaqueY = -1, lastOpaqueY = -1;

          for (let ly = lineTop; ly < lineBottom; ly++) {
            if (isOpaqueAt(x, ly)) {
              let consecutiveCount = 0;
              for (let checkY = ly; checkY <= Math.min(ly + 5, lineBottom - 1); checkY++) {
                if (isOpaqueAt(x, checkY)) consecutiveCount++;
                else break;
              }

              if (consecutiveCount >= 3) {
                if (firstOpaqueY === -1) firstOpaqueY = ly;
                lastOpaqueY = ly;
              }
            }
          }

          if (firstOpaqueY === -1) continue;

          let gapStart = -1;
          for (let ly = firstOpaqueY; ly <= lastOpaqueY; ly++) {
            const isTransparent = !isOpaqueAt(x, ly);

            if (isTransparent && gapStart === -1) {
              gapStart = ly;
            } else if (!isTransparent && gapStart !== -1) {
              if (ly - gapStart <= maxVerticalGap) {
                for (let gy = gapStart; gy < ly; gy++) fillPixel(x, gy);
              }
              gapStart = -1;
            }
          }
        }
      }

      if (lineYPositions.length > 1) {
        let globalMinX = width, globalMaxX = 0;
        let globalMinY = height, globalMaxY = 0;

        for (let y = 0; y < height; y++) {
          for (let x = 0; x < width; x++) {
            if (isOpaqueAt(x, y)) {
              globalMinX = Math.min(globalMinX, x);
              globalMaxX = Math.max(globalMaxX, x);
              globalMinY = Math.min(globalMinY, y);
              globalMaxY = Math.max(globalMaxY, y);
            }
          }
        }

        const lineSpacing = Math.abs(lineYPositions[1] - lineYPositions[0]);
        const maxInterLineGap = lineSpacing * 0.8;

        for (let x = globalMinX; x <= globalMaxX; x++) {
          let firstOpaqueY = -1, lastOpaqueY = -1;

          for (let y = globalMinY; y <= globalMaxY; y++) {
            if (isOpaqueAt(x, y)) {
              if (firstOpaqueY === -1) firstOpaqueY = y;
              lastOpaqueY = y;
            }
          }

          if (firstOpaqueY === -1) continue;

          let gapStart = -1;
          for (let y = firstOpaqueY; y <= lastOpaqueY; y++) {
            const isTransparent = !isOpaqueAt(x, y);

            if (isTransparent && gapStart === -1) {
              gapStart = y;
            } else if (!isTransparent && gapStart !== -1) {
              if (y - gapStart <= maxInterLineGap) {
                for (let gy = gapStart; gy < y; gy++) fillPixel(x, gy);
              }
              gapStart = -1;
            }
          }
        }

        const maxHorizontalGap = fontSize * 0.3;
        for (let y = globalMinY; y <= globalMaxY; y++) {
          let firstOpaqueX = -1, lastOpaqueX = -1;

          for (let x = globalMinX; x <= globalMaxX; x++) {
            if (isOpaqueAt(x, y)) {
              if (firstOpaqueX === -1) firstOpaqueX = x;
              lastOpaqueX = x;
            }
          }

          if (firstOpaqueX === -1) continue;

          let gapStart = -1;
          for (let x = firstOpaqueX; x <= lastOpaqueX; x++) {
            const isTransparent = !isOpaqueAt(x, y);

            if (isTransparent && gapStart === -1) {
              gapStart = x;
            } else if (!isTransparent && gapStart !== -1) {
              if (x - gapStart <= maxHorizontalGap) {
                for (let gx = gapStart; gx < x; gx++) fillPixel(gx, y);
              }
              gapStart = -1;
            }
          }
        }
      }

      return imageData;
    }

    // ============================================
    // MOCKUP APPLICATION
    // ============================================
    applyLogoToMockups(svgContent, selectedSize) {
      const size = selectedSize || this.getSelectedSize();
      // Store for later use when size changes
      this.lastUncroppedSvgHtml = svgContent;

      $('.wd-logo-preview__mockup').each(function () {
        const $mockup = $(this);
        const item = $mockup.attr('item');
        const $logo = $mockup.find('.wd-logo-preview_logo');

        const config = getConfigForSize(item, size) || getConfigForSize('laptop', size);

        const cssProps = {
          position: 'absolute',
          top: config.top,
          left: config.left,
          width: config.width,
          transform: config.transform,
          transformOrigin: config.transformOrigin,
          mixBlendMode: 'normal',
          opacity: 1,
          pointerEvents: 'none',
          zIndex: 10
        };

        if (config.clipPath) {
          cssProps.clipPath = config.clipPath;
        }

        $logo.css(cssProps).html(svgContent);

        $logo.find('svg').css({
          width: '100%',
          height: 'auto',
          display: 'block'
        });
      });
    }

    updateMockupsForSize() {
      if (this.lastUncroppedSvgHtml) {
        this.applyLogoToMockups(this.lastUncroppedSvgHtml, this.getSelectedSize());
      }
    }

    // ============================================
    // SYNC PREVIEWS - Updates all preview SVGs
    // ============================================
    syncAllPreviews() {
      if (!this.lastCroppedContent || !this.lastCroppedViewBox) return;

      const content = this.lastCroppedContent;
      const viewBox = this.lastCroppedViewBox;

      // Update preview SVGs ONLY - exclude mockup logos
      $('.preview-container svg.previewSvg, svg#previewSvg').not('.wd-logo-preview_logo svg, .wd-logo-preview_logo svg.previewSvg').each(function() {
          while (this.firstChild) {
              this.removeChild(this.firstChild);
          }
          this.innerHTML = content;
          this.setAttribute('viewBox', viewBox);
      });

      $('.preview-container').removeClass('loading');
    }

    // ============================================
    // MAIN RENDER FUNCTION
    // ============================================
    doRender() {
      const state = this.getState();
      const { text, fontFamily, bgColor, textColor, outlineColor, outlineThickness, shape } = state;

      const lines = text.split('\n').slice(0, 4);
      const nonEmptyLines = lines.filter(line => line.trim().length > 0);

      if (nonEmptyLines.length === 0 || !/\S/.test(text)) {
        $('.preview-container').removeClass('loading');
        return;
      }

      const selectedFont = FONTS.find(f => f.name === fontFamily) || FONTS[0];
      const ctx = this.renderCanvas.getContext('2d', { willReadFrequently: true });

      ctx.clearRect(0, 0, CONFIG.RENDER_SIZE, CONFIG.RENDER_SIZE);

      // Clear render SVG
      while (this.renderSvg.firstChild) {
        this.renderSvg.removeChild(this.renderSvg.firstChild);
      }

      // Reset viewBox to default
      this.renderSvg.setAttribute('viewBox', `0 0 ${CONFIG.CANVAS_SIZE} ${CONFIG.CANVAS_SIZE}`);

      // Create defs with drop shadow filter
      this.createSvgDefs();

      const { fontSize, lineYPositions, lineMeasurements } = this.calculateLayout(
        ctx, nonEmptyLines, selectedFont
      );

      // Render text to canvas for contour tracing
      ctx.font = `${selectedFont.weight} ${fontSize}px ${selectedFont.family}`;
      ctx.textAlign = 'left';
      ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = bgColor;
      ctx.strokeStyle = bgColor;
      ctx.lineWidth = fontSize * CONFIG.CANVAS_STROKE * (selectedFont.strokeMultiplier || 1.0);
      ctx.lineJoin = 'round';

      nonEmptyLines.forEach((line, index) => {
        const y = lineYPositions[index];
        const trimmedLine = line.trim();
        if (trimmedLine.length === 0) return;

        const leftX = lineMeasurements[index].leftX;
        ctx.strokeText(trimmedLine, leftX, y);
        ctx.fillText(trimmedLine, leftX, y);
      });

      const imageData = ctx.getImageData(0, 0, CONFIG.RENDER_SIZE, CONFIG.RENDER_SIZE);
      let opaquePixels = 0;
      for (let i = 3; i < imageData.data.length; i += 4) {
        if (imageData.data[i] > 128) opaquePixels++;
      }

      if (opaquePixels < 1000) {
        ctx.clearRect(0, 0, CONFIG.RENDER_SIZE, CONFIG.RENDER_SIZE);
        $('.preview-container').removeClass('loading');
        return;
      }

      let pathData = '';

      if (shape === 'rectangle') {
        pathData = this.generateRectanglePath(imageData);
      } else {
        const filledImageData = this.applyGapFilling(
          imageData, CONFIG.RENDER_SIZE, CONFIG.RENDER_SIZE,
          lineYPositions, fontSize, bgColor
        );
        ctx.putImageData(filledImageData, 0, 0);

        const finalImageData = ctx.getImageData(0, 0, CONFIG.RENDER_SIZE, CONFIG.RENDER_SIZE);
        pathData = this.traceContour(finalImageData, CONFIG.RENDER_SIZE, CONFIG.RENDER_SIZE);

        const scale = CONFIG.CANVAS_SIZE / CONFIG.RENDER_SIZE;
        pathData = pathData.replace(/([ML])\s*([\d.]+)\s+([\d.]+)/g, (match, cmd, x, y) => {
          return `${cmd} ${parseFloat(x) * scale} ${parseFloat(y) * scale}`;
        });
      }

      this.buildSvgContent(pathData, lineMeasurements, lineYPositions, fontSize, selectedFont, nonEmptyLines, state);
      ctx.clearRect(0, 0, CONFIG.RENDER_SIZE, CONFIG.RENDER_SIZE);
    }

    createSvgDefs() {
      const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');

      const filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
      filter.setAttribute('id', 'drop-shadow');
      filter.setAttribute('x', '-50%');
      filter.setAttribute('y', '-50%');
      filter.setAttribute('width', '200%');
      filter.setAttribute('height', '200%');

      const elements = [
        { tag: 'feGaussianBlur', attrs: { in: 'SourceAlpha', stdDeviation: '8', result: 'blur' } },
        { tag: 'feOffset', attrs: { in: 'blur', dx: '10', dy: '10', result: 'offsetBlur' } },
        { tag: 'feFlood', attrs: { 'flood-color': '#000000', 'flood-opacity': '0.45', result: 'color' } },
        { tag: 'feComposite', attrs: { in: 'color', in2: 'offsetBlur', operator: 'in', result: 'shadow' } }
      ];

      elements.forEach(({ tag, attrs }) => {
        const el = document.createElementNS('http://www.w3.org/2000/svg', tag);
        Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));
        filter.appendChild(el);
      });

      const feMerge = document.createElementNS('http://www.w3.org/2000/svg', 'feMerge');
      ['shadow', 'SourceGraphic'].forEach(input => {
        const node = document.createElementNS('http://www.w3.org/2000/svg', 'feMergeNode');
        node.setAttribute('in', input);
        feMerge.appendChild(node);
      });
      filter.appendChild(feMerge);

      defs.appendChild(filter);
      this.renderSvg.appendChild(defs);
    }

    calculateLayout(ctx, nonEmptyLines, selectedFont) {
      const padding = CONFIG.RENDER_SIZE * 0.05;
      const maxWidth = CONFIG.RENDER_SIZE - (padding * 2);
      const maxHeight = CONFIG.RENDER_SIZE - (padding * 2);

      let fontSize = 10;
      let maxFontSize = 1000;
      let minFontSize = 10;

      for (let i = 0; i < 20; i++) {
        fontSize = (maxFontSize + minFontSize) / 2;
        ctx.font = `${selectedFont.weight} ${fontSize}px ${selectedFont.family}`;

        let maxLineWidth = 0;
        nonEmptyLines.forEach(line => {
          const metrics = ctx.measureText(line.trim());
          maxLineWidth = Math.max(maxLineWidth, metrics.width);
        });

        const strokeWidth = fontSize * 0.6;
        const effectiveWidth = maxLineWidth + (strokeWidth * 2);
        const lineHeight = fontSize * selectedFont.lineHeight;
        const totalHeight = lineHeight * nonEmptyLines.length;
        const effectiveHeight = totalHeight + (strokeWidth * 2);

        if (effectiveWidth > maxWidth || effectiveHeight > maxHeight) {
          maxFontSize = fontSize;
        } else {
          minFontSize = fontSize;
        }
      }

      fontSize = minFontSize;
      ctx.font = `${selectedFont.weight} ${fontSize}px ${selectedFont.family}`;

      let lineYPositions = [];

      if (selectedFont.useXHeightSpacing) {
        lineYPositions = this.calculateXHeightSpacing(nonEmptyLines, fontSize);
      } else {
        const lineHeight = fontSize * selectedFont.lineHeight;
        const totalHeight = lineHeight * nonEmptyLines.length;
        let currentY = (CONFIG.RENDER_SIZE - totalHeight) / 2 + fontSize * 0.8;

        nonEmptyLines.forEach((_, index) => {
          lineYPositions.push(currentY + index * lineHeight);
        });
      }

      const lineMeasurements = nonEmptyLines.map(line => {
        const trimmedLine = line.trim();
        const metrics = ctx.measureText(trimmedLine);
        const textWidth = metrics.width;
        const leftX = (CONFIG.RENDER_SIZE - textWidth) / 2;
        return { width: textWidth, leftX };
      });

      return { fontSize, lineYPositions, lineMeasurements };
    }

    calculateXHeightSpacing(nonEmptyLines, fontSize) {
      const hasAscender = line => /[bdfhkltABCDEFGHIJKLMNOPQRSTUVWXYZ0-9]/.test(line);
      const hasDescender = line => /[gjpqy]/.test(line);
      const baseSpacing = fontSize * 0.85;

      const getSpacing = (lineAbove, lineBelow) => {
        const aboveHasDescender = hasDescender(lineAbove);
        const belowHasAscender = hasAscender(lineBelow);

        if (!aboveHasDescender && !belowHasAscender) return baseSpacing * 0.75;
        if (aboveHasDescender && belowHasAscender) return baseSpacing * 0.95;
        return baseSpacing * 0.85;
      };

      const lineYPositions = [];
      let currentY = CONFIG.RENDER_SIZE * 0.15 + fontSize * 0.8;

      nonEmptyLines.forEach((line, index) => {
        if (index === 0) {
          lineYPositions.push(currentY);
        } else {
          currentY += getSpacing(nonEmptyLines[index - 1], line);
          lineYPositions.push(currentY);
        }
      });

      const totalUsedHeight = lineYPositions[lineYPositions.length - 1] - lineYPositions[0];
      const verticalOffset = (CONFIG.RENDER_SIZE - totalUsedHeight) / 2 - lineYPositions[0];

      return lineYPositions.map(y => y + verticalOffset);
    }

    generateRectanglePath(imageData) {
      const threshold = 128;
      const rectPadding = 40;
      let minX = CONFIG.RENDER_SIZE, maxX = 0, minY = CONFIG.RENDER_SIZE, maxY = 0;

      for (let y = 0; y < CONFIG.RENDER_SIZE; y++) {
        for (let x = 0; x < CONFIG.RENDER_SIZE; x++) {
          const idx = (y * CONFIG.RENDER_SIZE + x) * 4;
          if (imageData.data[idx + 3] > threshold) {
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
          }
        }
      }

      const scale = CONFIG.CANVAS_SIZE / CONFIG.RENDER_SIZE;
      minX *= scale;
      maxX *= scale;
      minY *= scale;
      maxY *= scale;
      const scaledPadding = rectPadding * scale;

      const rectWidth = maxX - minX + (scaledPadding * 2);
      const rectHeight = maxY - minY + (scaledPadding * 2);
      const rectX = minX - scaledPadding;
      const rectY = minY - scaledPadding;
      const radius = 20;

      return `M ${rectX + radius} ${rectY}
        L ${rectX + rectWidth - radius} ${rectY}
        Q ${rectX + rectWidth} ${rectY} ${rectX + rectWidth} ${rectY + radius}
        L ${rectX + rectWidth} ${rectY + rectHeight - radius}
        Q ${rectX + rectWidth} ${rectY + rectHeight} ${rectX + rectWidth - radius} ${rectY + rectHeight}
        L ${rectX + radius} ${rectY + rectHeight}
        Q ${rectX} ${rectY + rectHeight} ${rectX} ${rectY + rectHeight - radius}
        L ${rectX} ${rectY + radius}
        Q ${rectX} ${rectY} ${rectX + radius} ${rectY}
        Z`;
    }

    // ============================================
    // BUILD SVG CONTENT AND DISTRIBUTE
    // ============================================
    buildSvgContent(pathData, lineMeasurements, lineYPositions, fontSize, selectedFont, nonEmptyLines, state) {
      const { bgColor, textColor, outlineColor, outlineThickness } = state;

      // Add background path
      if (pathData && pathData.length > 50) {
        const bgPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        bgPath.setAttribute('d', pathData);
        bgPath.setAttribute('fill', bgColor);
        bgPath.setAttribute('filter', 'url(#drop-shadow)');

        if (bgColor === '#FFFFFF') {
          bgPath.setAttribute('stroke', '#D1D5DB');
          bgPath.setAttribute('stroke-width', '1');
        }
        this.renderSvg.appendChild(bgPath);
      }

      const scale = CONFIG.CANVAS_SIZE / CONFIG.RENDER_SIZE;
      const svgFontSize = fontSize * scale;
      const svgLineYPositions = lineYPositions.map(y => y * scale);

      // Add text (in reverse order for proper layering)
      for (let i = nonEmptyLines.length - 1; i >= 0; i--) {
        const line = nonEmptyLines[i];
        const y = svgLineYPositions[i];
        const trimmedLine = line.trim();

        if (trimmedLine.length === 0) continue;

        const lineGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        const svgLeftX = lineMeasurements[i].leftX * scale;

        if (outlineThickness > 0) {
          const strokeText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
          strokeText.setAttribute('x', svgLeftX);
          strokeText.setAttribute('y', y);
          strokeText.setAttribute('font-family', selectedFont.family);
          strokeText.setAttribute('font-weight', selectedFont.weight);
          strokeText.setAttribute('font-size', svgFontSize);
          strokeText.setAttribute('text-anchor', 'start');
          strokeText.setAttribute('fill', 'none');
          strokeText.setAttribute('stroke', outlineColor);
          strokeText.setAttribute('stroke-width', svgFontSize * Math.pow(outlineThickness, 0.7) * 0.38);
          strokeText.setAttribute('stroke-linejoin', 'round');
          strokeText.setAttribute('stroke-linecap', 'round');
          strokeText.textContent = trimmedLine;
          lineGroup.appendChild(strokeText);
        }

        const fillText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        fillText.setAttribute('x', svgLeftX);
        fillText.setAttribute('y', y);
        fillText.setAttribute('font-family', selectedFont.family);
        fillText.setAttribute('font-weight', selectedFont.weight);
        fillText.setAttribute('font-size', svgFontSize);
        fillText.setAttribute('text-anchor', 'start');
        fillText.setAttribute('fill', textColor);
        fillText.textContent = trimmedLine;
        lineGroup.appendChild(fillText);

        this.renderSvg.appendChild(lineGroup);
      }

      // ========================================
      // STEP 1: Clone UNCROPPED SVG for mockups
      // ========================================
      const uncroppedClone = this.renderSvg.cloneNode(true);
      uncroppedClone.removeAttribute('id');
      uncroppedClone.classList.add('previewSvg');
      uncroppedClone.style.cssText = ''; // Remove positioning
      this.lastUncroppedSvgHtml = uncroppedClone.outerHTML;

      // Apply to mockups with UNCROPPED viewBox (600x600)
      this.applyLogoToMockups(this.lastUncroppedSvgHtml, this.getSelectedSize());

      // ========================================
      // STEP 2: Crop viewBox for preview display
      // ========================================
      this.renderSvg.style.left = '0';
      this.renderSvg.style.top = '0';
      this.renderSvg.style.visibility = 'hidden';
      this.renderSvg.style.opacity = '0';

      const bbox = this.renderSvg.getBBox();

      // Move back offscreen
      this.renderSvg.style.left = '-9999px';
      this.renderSvg.style.top = '-9999px';
      this.renderSvg.style.visibility = '';
      this.renderSvg.style.opacity = '';
      const padding = 15;
      const croppedViewBox = `${bbox.x - padding} ${bbox.y - padding} ${bbox.width + padding * 2} ${bbox.height + padding * 2}`;
      
      this.renderSvg.setAttribute('viewBox', croppedViewBox);
      
      // Store for PNG export
      this.lastViewBox = {
        x: bbox.x - padding,
        y: bbox.y - padding,
        width: bbox.width + padding * 2,
        height: bbox.height + padding * 2
      };

      // Store cropped content for syncing
      this.lastCroppedContent = this.renderSvg.innerHTML;
      this.lastCroppedViewBox = croppedViewBox;

      // ========================================
      // STEP 3: Sync to all preview SVGs
      // ========================================
      this.syncAllPreviews();
    }

    // ============================================
    // SVG UPLOAD
    // ============================================
    async svgUpload(options = {}) {
      const { uploadUrl = 'https://jetpackstickers.store/api/upload' } = options;

      const fileName = ($('#sticker-text').val() || 'say-it-with-sticker')
        .toLowerCase()
        .trim()
        .replace(/['"]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') + '.svg';

      const svg = this.renderSvg.cloneNode(true);
      svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svg.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
      svg.style.cssText = '';
      
      const style = document.createElementNS('http://www.w3.org/2000/svg', 'style');
      style.textContent = `@import url('https://fonts.googleapis.com/css2?family=Anton&family=Cookie&family=Kanit:wght@800&family=Monoton&family=Mystery+Quest&family=Orbitron:wght@700&family=Schoolbell&family=Uncial+Antiqua&display=swap');path {filter: none;}`;

      svg.insertBefore(style, svg.firstChild);
      const svgString = new XMLSerializer().serializeToString(svg);
      const svgBlob = new Blob([svgString], { type: 'image/svg+xml' });

      const file = new File([svgBlob], fileName, { type: 'image/svg+xml' });
      const formData = new FormData();
      formData.append('file', file);

      return new Promise((resolve, reject) => {
        $.ajax({
          url: uploadUrl,
          type: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          success: (response) => resolve(`https://jetpackstickers.store${response.fileUrl}`),
          error: (xhr) => reject(new Error(xhr.responseText || 'Upload failed'))
        });
      });
    }

    // ============================================
    // SVG TO PNG EXPORT
    // ============================================
    async svgToPngAndUpload(options = {}) {
      const {
        scale = 4,
        uploadUrl = 'https://jetpackstickers.store/api/upload'
      } = options;

      const fileName = ($('#sticker-text').val() || 'say-it-with-sticker')
        .toLowerCase()
        .trim()
        .replace(/['"]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') + '.png';

      try {
        const pngBlob = await this.renderSvgToPng(scale);
        return await this.uploadBlob(pngBlob, fileName, uploadUrl);
      } catch (error) {
        console.error('PNG export failed:', error);
        throw error;
      }
    }

    async renderSvgToPng(scale) {
      const svg = this.renderSvg.cloneNode(true);

      svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svg.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
      svg.style.cssText = '';

      const state = this.getState();
      const selectedFont = FONTS.find(f => f.name === state.fontFamily) || FONTS[0];

      const fontFace = await this.loadFontAsBase64(selectedFont);

      if (fontFace) {
        let defs = svg.querySelector('defs');
        if (!defs) {
          defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
          svg.insertBefore(defs, svg.firstChild);
        }

        const styleEl = document.createElementNS('http://www.w3.org/2000/svg', 'style');
        styleEl.textContent = fontFace;
        defs.insertBefore(styleEl, defs.firstChild);
      }

      // Get dimensions from viewBox
      let width, height;
      const vb = svg.getAttribute('viewBox');

      if (vb) {
        const parts = vb.trim().split(/[\s,]+/).map(Number);
        width = parts[2];
        height = parts[3];
      } else {
        width = CONFIG.CANVAS_SIZE;
        height = CONFIG.CANVAS_SIZE;
      }

      if (!width || !height) throw new Error('Could not determine SVG dimensions');

      svg.setAttribute('width', width);
      svg.setAttribute('height', height);

      const svgText = new XMLSerializer().serializeToString(svg);
      const svgBlob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
      const svgUrl = URL.createObjectURL(svgBlob);

      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';

        img.onload = () => {
          URL.revokeObjectURL(svgUrl);

          const canvasWidth = Math.round(width * scale);
          const canvasHeight = Math.round(height * scale);

          const canvas = document.createElement('canvas');
          canvas.width = canvasWidth;
          canvas.height = canvasHeight;

          const ctx = canvas.getContext('2d');
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.clearRect(0, 0, canvasWidth, canvasHeight);
          ctx.drawImage(img, 0, 0, canvasWidth, canvasHeight);

          canvas.toBlob((pngBlob) => {
            if (!pngBlob) return reject(new Error('Failed to create PNG blob'));
            resolve(pngBlob);
          }, 'image/png', 1.0);
        };

        img.onerror = () => {
          URL.revokeObjectURL(svgUrl);
          reject(new Error('Failed to render SVG'));
        };

        img.src = svgUrl;
      });
    }

    async uploadBlob(pngBlob, fileName, uploadUrl) {
      const file = new File([pngBlob], fileName, { type: 'image/png' });
      const formData = new FormData();
      formData.append('file', file);

      return new Promise((resolve, reject) => {
        $.ajax({
          url: uploadUrl,
          type: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          success: (response) => resolve(`https://jetpackstickers.store${response.fileUrl}`),
          error: (xhr) => reject(new Error(xhr.responseText || 'Upload failed'))
        });
      });
    }

    // ============================================
    // PRODUCT CREATION
    // ============================================
    async createProduct(imageUrl, svgUrl) {
      const state = this.getState();
      const quantity = parseFloat(this.getSelectedValue('wd-quantity'));
      const size = parseFloat(this.getSelectedValue('wd-size'));
      const price = this.calculateFinalPrice();

      const productData = {
        product_name: $('[name="product_name"]').val(),
        shape: state.shape || $('[name="product_name"]').val(),
        size,
        uv_laminate: state.laminate,
        price,
        image_url: imageUrl,
        instructions: state.text
      };

      try {
        const response = await $.ajax({
          url: 'https://jetpackstickers.store/api/create-product',
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(productData)
        });

        if (!response.product?.id) {
          throw new Error('Product creation failed');
        }

        let attachment = response.product.image?.src || imageUrl;
        if (/\.(pdf|ai|svg|eps|cdr)$/i.test(imageUrl)) {
          attachment = imageUrl;
        }

        const lineItemData = {
          id: response.product.variants[0].id,
          quantity: 1,
          properties: {
            'Details': `${size}-inches ${state.shapeText} Cut ${state.laminate} UV Laminate Waterproof Die Cut Stickers`,
            'Quantity': quantity,
            '_Preview': attachment,
            '_svg_url': svgUrl,
            '_Shape': state.shape,
            '_Logo Text': state.text,
            '_Font Family': state.fontFamily,
            '_Text Color': state.textColor,
            '_Outline Color': state.outlineColor,
            '_Outline Width': $('.wd-outline-range').val(),
            '_Background Color': state.bgColor,
            '_UV Laminate': state.laminate
          }
        };

        await $.ajax({
          url: '/cart/add.js',
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({ items: [lineItemData] })
        });

        $('#wd-sweet-design-popup-wrapper').css('display', 'flex');

        fetch('/cart.js').then(r => r.json()).then(cart => {
          $('.wd-cart-count').html(cart.item_count);
          $('.cart-count-bubble [data-cart-count]').html(cart.item_count);
          $('.wd-sticky-add-to-cart').show();
          $('.mrk-final-add-to-cart').html(window.btn_text).prop('disabled', false);
        });

      } catch (error) {
        console.error('Error:', error);
        $('.mrk-final-add-to-cart').text('Error! Try Again').removeAttr('disabled');
      }
    }

    // ============================================
    // PRICING
    // ============================================
    calculatePrice(size, qty) {
      return PRICE_GRID[size]?.[qty] || 0;
    }

    formatMoney(amount) {
      return Shopify.formatMoney(amount, window.money_format);
    }

    calculateFinalPrice() {
      const quantity = parseFloat($('[name="wd-quantity"]:checked').val());
      const size = parseFloat($('[name="wd-size"]:checked').val());
      const price = this.calculatePrice(size, quantity) * 100;

      $('.mrk-final-add-to-cart span').html(this.formatMoney(price).replace('.00', ''));
      return price;
    }

    updateSize() {
      const size = parseFloat($('[name="wd-size"]:checked').val());

      $('[name="wd-quantity"]').each((_, el) => {
        const $el = $(el);
        const quantity = parseFloat($el.val());
        const price = this.formatMoney((this.calculatePrice(size, quantity)) / quantity * 100).replace('.00', '');
        $el.parents('label').find('.wd-sq-pill-sub').html(price);
      });

      this.calculateFinalPrice();
      this.updateMockupsForSize();
    }

    // ============================================
    // UI UPDATE FUNCTIONS
    // ============================================
    updateOutlineFill() {
      const value = parseInt($('.wd-outline-range').val()) || 0;
      $('.wd-outline-fill').css('width', `${(value / 10) * 100}%`);
    }

    renderSticker() {
      clearTimeout(this.renderTimeout);
      this.renderTimeout = setTimeout(() => this.doRender(), 100);
    }

    updatePreview() {
      $('.preview-container').addClass('loading');
      $('details').removeAttr('open');
      this.renderSticker();
    }

    debouncedPreview() {
      clearTimeout(this.previewTimeout);
      this.previewTimeout = setTimeout(() => this.updatePreview(), CONFIG.DEBOUNCE_MS);
    }

    // ============================================
    // EVENT BINDINGS
    // ============================================
    bindEvents() {
      const self = this;

      // Text input
      $('#sticker-text').on('input', () => this.debouncedPreview());

      // Radio/checkbox changes that require re-render
      const immediateUpdateInputs = [
        'input[name="shape"]',
        'input[name="wd-font"]',
        'input[name="wd-text-color"]',
        'input[name="wd-outline-color"]',
        'input[name="wd-bg-color"]'
      ];

      $(immediateUpdateInputs.join(', ')).on('change', () => this.updatePreview());

      // Size change
      $('[name="wd-size"]').on('change', () => this.updateSize());

      // Quantity change
      $('[name="wd-quantity"]').on('change', () => this.calculateFinalPrice());

      // Outline slider
      $('.wd-outline-range').on('input', () => {
        this.updateOutlineFill();
        this.debouncedPreview();
      });

      // Tool dropdowns
      $(document).on('click', (e) => {
        if (!$(e.target).closest('.wd-tool').length) {
          $('.wd-tool').removeAttr('open');
        }
      });

      // Add to cart
      $('.mrk-final-add-to-cart').on('click', async () => {
        window.btn_text = $('.mrk-final-add-to-cart').html();
        try {
          $('.mrk-final-add-to-cart').attr('disabled', true).text('Processing...');
          const imageUrl = await this.svgToPngAndUpload();
          const svgUrl = await this.svgUpload();
          await this.createProduct(imageUrl, svgUrl);
        } catch (error) {
          console.error('Error:', error);
          $('.mrk-final-add-to-cart').text('Error! Try Again').removeAttr('disabled');
        }
      });

      // Re-sync previews when Slick slider changes (handles cloned slides)
      $('.wd-main-slider-wrapper, .wd-thumbnail-slider-wrapper').on('afterChange init', () => {
        // Small delay to let Slick finish DOM manipulation
        setTimeout(() => self.syncAllPreviews(), 50);
      });
    }

    async preloadFonts() {
      const fontUrl = 'https://fonts.googleapis.com/css2?family=Anton&family=Cookie&family=Kanit:wght@800&family=Monoton&family=Mystery+Quest&family=Orbitron:wght@700&family=Schoolbell&family=Uncial+Antiqua&display=swap';

      if (!document.querySelector(`link[href="${fontUrl}"]`)) {
        const link = document.createElement('link');
        link.href = fontUrl;
        link.rel = 'stylesheet';
        document.head.appendChild(link);
      }

      const fontChecks = FONTS.map(font => {
        const familyName = font.googleFont.split(':')[0].replace(/\+/g, ' ');
        return document.fonts.load(`${font.weight} 48px "${familyName}"`);
      });

      try {
        await Promise.all(fontChecks);
        await document.fonts.ready;
      } catch (e) {
        console.warn('Font preload warning:', e);
      }
    }

    // ============================================
    // INITIALIZATION
    // ============================================
    async init() {
      await this.preloadFonts();
      this.bindEvents();
      this.updateOutlineFill();
      this.updatePreview();
      this.updateSize();
      this.calculateFinalPrice();
    }
  }

  // Initialize when DOM is ready
  $(document).ready(async () => {
    window.stickerDesigner = new StickerDesigner();
  });

  // Color and font tool handlers
  $('.wd-tool-color, .wd-tool--font').each(function () {
    var $tool = $(this),
      isColor = $tool.hasClass('wd-tool-color'),
      selector = isColor ? '.wd-color-input:checked' : '.wd-font-option-input:checked';

    function updateVars() {
      var $checked = $tool.find(selector);
      if (!$checked.length) return;

      if (isColor) {
        $tool.css('--wd-selected-color', $checked.val());
      } else {
        $tool.css('--wd-selected-font', $checked.next('span').css('font-family'));
      }
    }

    $tool.on('change', 'input[type="radio"]', updateVars);
    updateVars();
  });

  // Popup close handler
  $('.mrk-sweet-popup-close').click(function (e) {
    e.preventDefault();
    $('#wd-sweet-design-popup-wrapper').hide();
  });

  // Slick sliders
  var slickDefaults = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
  };

  $('.wd-main-slider-wrapper').slick($.extend({}, slickDefaults, {
    fade: true,
    adaptiveHeight: true,
    asNavFor: '.wd-thumbnail-slider-wrapper'
  }));

  $('.wd-thumbnail-slider-wrapper').slick($.extend({}, slickDefaults, {
    slidesToShow: 5,
    asNavFor: '.wd-main-slider-wrapper',
    focusOnSelect: true,
    responsive: [{
      breakpoint: 1224,
      settings: { vertical: false, slidesToShow: 4, slidesToScroll: 1 }
    },
    {
      breakpoint: 769,
      settings: { vertical: true, slidesToShow: 5, slidesToScroll: 1 }
    }
    ]
  }));

})(jQuery);